import homePage from "./homePage"
import baoguo from "./baoguo"
import yunfei from "./yunfei"
import my from "./my"
export default{
    homePage,
    baoguo,
    yunfei,
    my
}